import React from 'react';
import BackButton from '@/components/BackButton';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <BackButton />
        </div>

        {/* Content */}
        <div className="space-y-6">
          <h1 className="text-2xl font-semibold text-foreground">À propos</h1>
          
          <div className="prose prose-sm text-muted-foreground leading-relaxed space-y-4">
            <p>
              Cette IA n'est pas généraliste. Elle est spécialisée dans l'analyse politique, idéologique et métapolitique. Elle ne répond pas aux questions hors de ce champ (par exemple : recettes, bricolage, conseils pratiques du quotidien, biographies).
            </p>
            
            <p>
              Le positionnement politique est assumé et structurant : les réponses sont produites à partir d'un cadre intellectuel cohérent, et non d'une neutralité abstraite ou artificielle.
            </p>
            
            <p>
              Les sources sont, à ce stade, volontairement limitées. L'IA peut répondre de manière pertinente sur les thématiques suivantes :
            </p>
            
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Analyse politique et institutionnelle française et européenne</li>
              <li>Idées, doctrines, courants intellectuels et débats contemporains</li>
              <li>Métapolitique, culture, histoire des idées</li>
              <li>Lecture critique de l'actualité et des discours médiatiques</li>
            </ul>
            
            <p>
              En dehors de ces domaines, les réponses peuvent être incomplètes ou inexistantes. Cela fait partie du périmètre actuel de l'outil.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
